export default () => `
  {
    shoeFinder {
      questions {
        id
        title
        description
        answers {
          id
          title
          description
        }
      }
      items {
        product {
          id
          name
          summary
          labels
          price
          variants {
            id
            isBackorderable
            labels
            colorName
            productUrl
            imageUrl
            backgroundImageUrl
            backgroundVideoUrl
            colorCodePrimary
            colorCodeSecondary
            skus
            spreeProduct
            availabilityDate
            filterValues
            soldItems
          }
        }
        specs
        position
      }
    }
  }
`
